module.exports = __webpack_public_path__ + "assets/images/d2e274e91ab5ebcf259c263753ca9d78.png";